import { Component, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { FormFieldType } from '../../enum/form.field.type';
import { FormType } from '../../enum/form.type';
import { SelectOption } from 'src/app/model/select.option';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/component/confirmation-dialog/confirmation-dialog.component';
import { FormField } from 'src/app/model/form.field';

@Component({
  selector: 'app-form-question',
  templateUrl: './form-question.component.html',
  styleUrls: ['./form-question.component.scss']
})
export class FormQuestionComponent {

  @Input() formController: FormGroup;
  @Input() index: number;
  @Input() formType: string;
  @Input() formForm: FormGroup;
  @Input() blockEdition: boolean;
  @Input() originalField: FormField;
  fieldTypeValues: Array<SelectOption> = FormFieldType.toSelectable();

  constructor(private fb: FormBuilder, private dialog: MatDialog) {}

  get hasAnswers(): boolean {
    return !!this.originalField?.hasAnswers();
  }

  choiceHasAnswers(choiceIndex: number): boolean {
    const choiceId = this.formController.value?.choices?.[choiceIndex]?.id;
    if (!choiceId) {
      return false;
    }
    return !!this.originalField?.choices?.find(choice => choice.id === choiceId)?.hasAnswers();
  }

  addNewChoice(): void {
    const control = <FormArray>this.formController.get('choices');
    const newControl = this.fb.group({
      description: ['New Choice', [Validators.required, Validators.minLength(1), Validators.maxLength(500)]],
      order: [1],
      value: [0, [Validators.required, Validators.min(0)]],
    });
    control.push(newControl);
  }

  deleteChoice(choiceIndex: number): void {
    if (this.formType === FormType.SUBMISSION && this.choiceHasAnswers(choiceIndex)) {
      this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: 'admin.event.settings.forms.confirm-delete-choice.title',
          content: 'admin.event.settings.forms.confirm-delete-choice.content',
          destructive: true
        }
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.removeChoice(choiceIndex);
        }
      });
    } else {
      this.removeChoice(choiceIndex);
    }
  }

  private removeChoice(choiceIndex: number): void {
    let formUpdate = this.formController.controls.choices as FormArray;
    formUpdate.removeAt(choiceIndex);
  }

  deleteQuestion(choiceIndex: number): void {
    if (this.formType === FormType.SUBMISSION && this.hasAnswers) {
      this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: 'admin.event.settings.forms.confirm-delete-question.title',
          content: 'admin.event.settings.forms.confirm-delete-question.content',
          destructive: true
        }
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.removeQuestion(choiceIndex);
        }
      });
    } else {
      this.removeQuestion(choiceIndex);
    }
  }

  private removeQuestion(choiceIndex: number): void {
    let formUpdate = this.formForm.controls.fields as FormArray;
    formUpdate.removeAt(choiceIndex);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.formController.controls['choices']['controls'], event.previousIndex, event.currentIndex);
    moveItemInArray(this.formController.value.choices, event.previousIndex, event.currentIndex);
  }
}
